import moment from "moment";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import TitleModal from "../components/common/titleModal";
import ButtonSubmit from "../components/common/buttonSubmit";
import InputFiled from "../components/common/inputFiled";
import { useGetNextMeeting, useVerifyMeeting } from "../hooks/useMeeting";
import { getAxiosTranslatedError } from "../utils/helpers";
import MeetingBox from "../components/meetingBox";
import TelemedicinePage from "../components/telemedicinePage";

function TelemedicinePharmacy() {
  const { t } = useTranslation()

  const { eventUuid = '' } = useParams()
  const navigate = useNavigate()
  const location = useLocation()

  const { data: nextMeeting } = useGetNextMeeting(eventUuid)
  const { mutate: verifyMeeting, isPending: verifyMeetingIsPending } = useVerifyMeeting()

  const [showForm, setShowForm] = useState(true)
  const [showConfirm, setShowConfirm] = useState(false)

  const [bookingId, setBookingId] = useState('')
  const [healthCardLastDigits, setHealthCardLastDigits] = useState('')
  const [errorMessage, setErrorMessage] = useState('')

  const [confirmedMeeting, setConfirmedMeeting] = useState(null)
  const [meetingToken, setMeetingToken] = useState('')

  function handleConfirm() {
    verifyMeeting(
      { bookingId, healthCardLastDigits },
      {
        onSuccess: ({ meeting, token }) => {
          setErrorMessage('')
          setConfirmedMeeting(meeting)
          setMeetingToken(token)
          setShowForm(false)
          setShowConfirm(true)
        },
        onError: (error: any) => {
          setErrorMessage(getAxiosTranslatedError(error))
        },
      }
    )
  }

  function handleStartVisit() {
    navigate(`/telemedicine/meeting/${meetingToken}`, {
      state: { from: location.pathname },
    })
  }

  const Form = <>
    {nextMeeting &&
      <MeetingBox
        title={t("telemedicine-join.meeting-title")}
        meeting={nextMeeting}
      />
    }
    <p>{t("telemedicine-join.insert-your-data")}</p>

    {/* Booking ID */}
    <div className="text-left">
      <label className="ms-2 label-sm">
        {t("telemedicine-join.booking-id")}
      </label>

      <InputFiled
        value={bookingId}
        name="bookingId"
        handleChange={setBookingId}
      />
    </div>

    {/* Health Card Number */}
    <div className="text-left">
      <label className="ms-2 label-sm">
        {t("telemedicine-join.health-card-last-5-digits")}
      </label>

      <InputFiled
        value={healthCardLastDigits}
        name="healthCardLastDigits"
        handleChange={setHealthCardLastDigits}
      />
    </div>

    <div className="mt-4">
      <ButtonSubmit
        disabled={!bookingId || !healthCardLastDigits}
        className="btnMeeting"
        textButton={!verifyMeetingIsPending ? t("telemedicine-join.confirm") : ""}
        spinner={verifyMeetingIsPending}
        handleChange={() => handleConfirm()}
      />
    </div>

    {errorMessage && (
      <div className="warning-box mt-2">
        <span className="material-icons warning-icon-size text-warning">
          warning
        </span>
        <span className="warning-text-size text-warning ms-2">
          {errorMessage}
        </span>
      </div>
    )}
  </>

  const Confirm = <>
    <TitleModal title={t("telemedicine-join.confirmed-meeting-title")} />
    <TitleModal title={t("telemedicine-join.confirmed-meeting-title2")} />

    <MeetingBox
      meeting={confirmedMeeting}
    />

    <div className="mt-4">
      <ButtonSubmit
        className="btnMeeting"
        textButton={t("telemedicine-join.start-visit")}
        handleChange={() => handleStartVisit()}
      />
    </div>
  </>

  return (
    <TelemedicinePage>
      {showForm && Form}
      {showConfirm && Confirm}
    </TelemedicinePage>
  );
}

export default TelemedicinePharmacy;
